import apiBase from './apiBase'
import dataUriToBlob from '../utils/dataUriToBlob';
import moment from 'moment'

const toFormData = values => {
  const body = new FormData()
  const fields = {
    name: values.name,
    description: values.description,
    targetUrl: values.targetUrl,
    order: values.order
  }

  Object.entries(fields).forEach(([name, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      body.append(name, String(value))
    }
  })

  if (values.validFrom) {
    body.append('validFrom', moment(values.validFrom).toISOString())
  }
  if (values.validTo) {
    body.append('validTo', moment(values.validTo).toISOString())
  }

  const tenantScope = values.tenantScope || []
  tenantScope.forEach((tenantId, index) => {
    body.append(`tenantScope[${index}]`, String(tenantId))
  })

  const placements = values.placements || []
  placements.forEach((placement, index) => {
    body.append(`placements[${index}]`, String(placement))
  })

  const platforms = ['mobile', 'web']
  platforms.forEach(platform => {
    const styles = (values.styles && values.styles[platform]) || {}

    if (styles.width !== '' && styles.width !== null && styles.width !== undefined) {
      body.append(`styles.${platform}.width`, String(styles.width))
    }
    if (styles.height !== '' && styles.height !== null && styles.height !== undefined) {
      body.append(`styles.${platform}.height`, String(styles.height))
    }
  })

  if (values.mainImage) {
    const blob = dataUriToBlob(values.mainImage)
    body.append('mainImage', blob, 'mainImage')
  }

  return body
}

export default class AdvertisementsApi {
  static list (pageNumber, pageSize, sortBy, filterBy) {
    return apiBase.create().post('/advertisements/list', {
      paging: {
        pageNumber: Math.max(1, pageNumber),
        pageSize: Math.max(1, pageSize)
      },
      sortBy: Object.assign(
        {},
        ...(sortBy.length ? sortBy : [{ id: 'createdAt', value: 'desc' }]).map(
          x => ({ [x.id]: x.value })
        )
      ),
      filterBy: Object.assign({}, ...filterBy.map(x => ({ [x.id]: x.value })))
    })
  }

  static getDetails (id) {
    return apiBase.create().get(`/advertisements/${encodeURIComponent(id)}`)
  }

  static create (values) {
    return apiBase.create().post('/advertisements', toFormData(values))
  }

  static update (id, values) {
    return apiBase
      .create()
      .put(`/advertisements/${encodeURIComponent(id)}`, toFormData(values))
  }

  static publish (id) {
    return apiBase
      .create()
      .post(`/advertisements/${encodeURIComponent(id)}/publish`)
  }

  static delete (id) {
    return apiBase.create().delete(`/advertisements/${encodeURIComponent(id)}`)
  }
}
